

export default function Line() {
  return (
	<div className="h-[1px] bg-gray-200 max-w-custom mx-auto"></div>
  );
}